import { t } from '@lingui/core/macro';
import { TLoanPurpose } from 'lendingApi/applications.types';

type PurposeOfFundsOptions = {
  value: TLoanPurpose;
  label: string;
  enabledForDE: boolean;
  enabledForUK: boolean;
  description?: string;
}[];

export const PURPOSEOPTIONS = (): PurposeOfFundsOptions => [
  {
    value: 'acquisition',
    label: t`Acquiring a business`,
    enabledForDE: false,
    enabledForUK: true,
    description: `Please share details on 1. the business name and company number being acquired, 2. the cost and motivation of the acquisition, 3. if there will be any deferred consideration, 4. where the remaining funds will come from if this doesn’t cover the full acquisition costs or if iwoca cannot facilitate the full request.`,
  },
  {
    value: 'expansion',
    label: t`Business or headcount expansion`,
    enabledForDE: false,
    enabledForUK: true,
  },
  {
    value: 'shareholder_buyout',
    label: t`Buying out other shareholders`,
    enabledForDE: false,
    enabledForUK: true,
    description: `Please share details on 1. the shareholder(s) being bought out and their reason(s) for selling, 2. whether the shareholder(s) in question will be involved in the day-to-day operations post buy-out, 3. the total buy-out cost, 4. if there are any deferred considerations and their terms, 5. where the remaining funds will come from if this doesn’t cover the full buy-out costs or if iwoca cannot facilitate your full request.`,
  },
  {
    value: 'property_renovations',
    label: t`Property renovations`,
    enabledForDE: false,
    enabledForUK: true,
  },
  {
    value: 'property_purchase',
    label: t`Purchasing commercial property`,
    enabledForDE: false,
    enabledForUK: true,
    description: `Please share details on 1. the address of the property being purchased, 2. its total cost, 3. whether it is being bought outright and if not what the mortgage terms will be (specifically, monthly repayments), 4. the use and impact of the new property.`,
  },
  {
    value: 'refinancing_debt',
    label: t`Refinancing existing debt`,
    enabledForDE: true,
    enabledForUK: true,
    description: `Please share details on 1. which debts specifically you would like to refinance, 2. the outstanding balance(s) of the debt, 3. the interest rate(s) on the loan(s) you are looking to refinance.`,
  },
  {
    value: 'marketing',
    label: t`Marketing`,
    enabledForDE: true,
    enabledForUK: true,
  },
  {
    value: 'equipment_purchase',
    label: t`Purchasing equipment`,
    enabledForDE: true,
    enabledForUK: true,
  },
  {
    value: 'pay_bill',
    label: t`Paying bills`,
    enabledForDE: true,
    enabledForUK: false,
  },
  {
    value: 'stock_purchase',
    label: t`Purchasing stock`,
    enabledForDE: true,
    enabledForUK: true,
  },
  {
    value: 'bridging_loan',
    label: t`Bridging loan`,
    enabledForDE: true,
    enabledForUK: false,
  },
  {
    value: 'pay_staff',
    label: t`Paying wages`,
    enabledForDE: true,
    enabledForUK: true,
  },
  {
    value: 'pay_tax_bill',
    label: t`Paying taxes`,
    enabledForDE: true,
    enabledForUK: true,
    description: `Please share details on 1. which taxes are currently overdue and how much is owed for each, 2. whether you have any current or scheduled NDDS arrangements with HMRC and what they are for, what the monthly repayment terms are, and how long you expect them to last.`,
  },
  {
    value: 'financing_client_order',
    label: t`Financing client order`,
    enabledForDE: true,
    enabledForUK: false,
  },
  {
    value: 'personal_loan' as TLoanPurpose,
    label: t`Personal loan`,
    enabledForDE: true,
    enabledForUK: false,
  },
  {
    value: 'other',
    label: t`Other purpose`,
    enabledForDE: true,
    enabledForUK: true,
  },
];
